import React, { useState } from "react";
import "../../styles/glass.css";
import "../../styles/globals.css";
import "../../styles/layout.css";
import "../styles/platform.css";
import "../styles/LeftSidebar.css";

import HeaderPlatform from "../components/HeaderPlatform";
import FooterPlatform from "../components/FooterPlatform";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import { useNavigate } from "react-router-dom";
import { submitConsent } from "../api/intakeApi";

export const HealthDataConsentPage = () => {
  const navigate = useNavigate();
  const currentLang = useCurrentLang();

  const [healthConsentAgreed, setHealthConsentAgreed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const handleSubmit = async () => {
    if (!healthConsentAgreed) {
      setSubmitError("You must agree before continuing.");
      return;
    }

    setIsSubmitting(true);
    setSubmitError("");

    try {
      await submitConsent({
        consent_type: "health_data_processing",
        consent_text_version: "v1",
        granted: true,
      });

      navigate(`/${currentLang}/platform/form`);
    } catch (error) {
      console.error("Consent submit error:", error);
      setSubmitError(error.message || "Failed to save consent.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="revimo-layout">
      <HeaderPlatform />

      <main className="revimo-main">
        <div className="revimo-page-content">
          <div className="intake-alert-shell">
            <div className="intake-alert-box">
              <h3>Health data safety notice</h3>

              <p>
                The following “red flag” questions involve health-related
                information. Revimo will use your answers only to check whether
                it is safe for you to perform the suggested exercises and to
                avoid unwanted complications for you.
              </p>

              <p>
                Your responses will not be shared with third parties and will
                not be used for advertising or other unrelated purposes. You
                can withdraw this consent later in your account settings as
                described in our{" "}
                <a
                  href={`/${currentLang}/privacy-policy`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
                .
              </p>

              <label className="consent-label">
                <input
                  type="checkbox"
                  className="consent-checkbox"
                  checked={healthConsentAgreed}
                  onChange={(e) => {
                    setHealthConsentAgreed(e.target.checked);
                    if (e.target.checked) setSubmitError("");
                  }}
                  disabled={isSubmitting}
                />
                <span className="consent-text">
                  I understand and agree that Revimo may process my health-related
                  information in this intake only to assess whether it is safe
                  for me to perform the suggested exercises and to prevent
                  possible complications.
                </span>
              </label>

              {submitError && (
                <p style={{ color: "#b42318", marginTop: "12px" }}>
                  {submitError}
                </p>
              )}

              <div
                className="intake-final-actions"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "18px",
                  marginTop: "18px",
                }}
              >
                <button
                  type="button"
                  style={{
                    padding: "12px 26px",
                    borderRadius: 999,
                    backgroundColor: "#176B87",
                    color: "white",
                    fontWeight: 600,
                    opacity: isSubmitting ? 0.7 : 1,
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                  }}
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "I consent and continue"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="revimo-footer">
        <FooterPlatform />
      </footer>
    </div>
  );
};

export default HealthDataConsentPage;